import {
  reauthenticateWithCredential,
  reauthenticateWithPopup,
  EmailAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  User,
  SAMLAuthProvider,
  GithubAuthProvider,
} from "firebase/auth";
import { Dispatch } from "../auth-context";

export const reauthenticateUser = async (params: {
  user: User;
  password?: string;
  dispatch: Dispatch;
}): Promise<void> => {
  const { user, password, dispatch } = params;
  const signInMethod = user.providerData[0]?.providerId;
  if (!signInMethod) {
    throw new Error("No sign-in method found for user");
  }
  dispatch({ type: "set reauthentication begin", status: "pending" });

  try {
    switch (signInMethod) {
      // Email/Password requires password input
      case "password":
        if (!password || !user.email) {
          throw new Error(
            "Password and email are required for reauthentication",
          );
        }
        const credential = EmailAuthProvider.credential(user.email, password);
        await reauthenticateWithCredential(user, credential);
        dispatch({ type: "reauthentication success", user, status: "idle" });
        break;

      case "google.com":
        const googleProvider = new GoogleAuthProvider();
        await reauthenticateWithPopup(user, googleProvider);
        dispatch({ type: "reauthentication success", user, status: "idle" });
        break;

      case "github.com":
        const githubProvider = new GithubAuthProvider();
        await reauthenticateWithPopup(user, githubProvider);
        dispatch({ type: "reauthentication success", user, status: "idle" });
        break;

      case "microsoft.com":
        const msftProvider = new OAuthProvider("microsoft.com");
        await reauthenticateWithPopup(user, msftProvider);
        dispatch({ type: "reauthentication success", user, status: "idle" });
        break;

      default:
        if (signInMethod?.startsWith("saml.")) {
          const samlProvider = new SAMLAuthProvider(signInMethod);
          await reauthenticateWithPopup(user, samlProvider);
        } else {
          throw new Error(`Unsupported sign-in method: ${signInMethod}`);
        }
    }
  } catch (error) {
    console.error("Reauthentication error:", error);
    throw error;
  }
};
